import CollegeInfo from 'modules/Roles/Partials/ViewCollegeDetails/Partials/CollegeInfo'
import Header from 'modules/Roles/Partials/ViewCollegeDetails/Partials/Header'
import ViewCandidateDetails from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { degreeListConvertion } from 'utils/degreeListConvertion'

const ViewCollegeDetails = ({
  getInstituteCampusDetails,
  instituteCampusDetails,
  getSingleRoleData,
  singleRoleData,
  listOfCities,
  getCities,
  getAppliedCollegesList,
  getAppliedCandidateList,
  corporateId,
  createDrive,
  getListOfDegree,
  listOfDegree,
  getInstitutesList,
  institutesList,
  setInstitutesList,
  getCandidateDetails,
  getPromotion,
  candidateDetails,
  driveList,
  getDegreesBasedOnRoles,
  roleBasedDegreeList,
  getDriveCreatedCandidates,
  getDriveNotCreatedCandidates,
  getDriveCreatedCandidatesPreview,
  DriveNotCreatedCandidates,
  DriveCreatedCandidates,
  DriveCreatedCandidatesPreview,
  getUserCorpList,
  setCandidatesCount,
  draftData,
  resumeBulkDownload,
  roleId,
}) => {
  const params = useParams()
  const [viewDrawer, setViewDrawer] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isAllSelected, setIsAllSelected] = useState(false)
  const [createDriveDrawer, setCreateDriveDrawer] = useState(false)
  const [hostCollegeDrawer, setHostCollegeDrawer] = useState('')
  const [addCollegeDrawer, setAddCollegeDrawer] = useState('')
  const [previewDrawer, setPreviewDrawer] = useState('')
  const [degreeListData, setDegreeListData] = useState([])
  const [degreeSearch, setDegreeSearch] = useState('')

  const [selectedCity, setSelectedCity] = useState('')
  const [selectedCityName, setSelectedCityName] = useState('')
  const [hostCollegeId, setHostCollegeId] = useState('')
  const [selectedInstitute, setSelectedInstitute] = useState({})
  const [poolInstituteIds, setPoolInstituteIds] = useState('')
  const [poolInstitutesData, setPoolInstitutesData] = useState([])
  const [searchCity, setSearchCity] = useState('')
  const [instituteDetails, setInstituteDetails] = useState({})
  const [driveName, setDriveName] = useState('')

  useEffect(() => {
    if (singleRoleData?.length == 0) {
      getSingleRoleData(0,params?.jobId)
    }
    getInstituteCampusDetails({ instituteCampusId: params?.instituteCampusId })
    getInstituteDetails()
  }, [])

  const getInstituteDetails = async () => {
    const { data, status } = await getAppliedCollegesList({
      setLoading: setLoading,
      roleId: params?.jobId,
      instituteCampusIds: params?.instituteCampusId,
    })
    if (status >= 200 && status <= 300) {
      setInstituteDetails(data?.data?.result)
    }
  }
  useEffect(() => {
    setSelectedCity(instituteCampusDetails?.cityId)
    setSearchCity(instituteCampusDetails?.city)
  }, [instituteCampusDetails])

  useEffect(() => {
    let getData
    getData = setTimeout(() => {
      getListOfDegree({ searchValue: degreeSearch })
    }, 500)

    return () => clearTimeout(getData)
  }, [degreeSearch])

  useEffect(() => {
    const updatedData = degreeListConvertion({ listOfDegree: listOfDegree })
    setDegreeListData(updatedData)
  }, [listOfDegree])

  return (
    <>
      <Header
        instituteCampusDetails={instituteCampusDetails}
        setCreaterDriveDrawer={setCreateDriveDrawer}
        instituteDetails={instituteDetails}
        getUserCorpList={getUserCorpList}
        loading={loading}
      />

      <CollegeInfo
        draftData={draftData}
        setViewDrawer={setViewDrawer}
        getAppliedCandidateList={getAppliedCandidateList}
        getInstitutesList={getInstitutesList}
        institutesList={institutesList}
        setInstitutesList={setInstitutesList}
        degreeListData={degreeListData}
        getCandidateDetails={getCandidateDetails}
        instituteCampusDetails={instituteCampusDetails}
        instituteDetails={instituteDetails}
        getDegreesBasedOnRoles={getDegreesBasedOnRoles}
        roleBasedDegreeList={roleBasedDegreeList}
        resumeBulkDownload={resumeBulkDownload}
        isAllSelected={isAllSelected}
        setIsAllSelected={setIsAllSelected}
      />

      <ViewCandidateDetails
        viewDrawer={viewDrawer}
        setViewDrawer={setViewDrawer}
        singleStudentData={candidateDetails}
        getPromotion={getPromotion}
        roleId={roleId}

      />
    </>
  )
}

export default ViewCollegeDetails
